type BreakpointsHashTable<T> = {
  tiny: T;
  small: T;
  medium: T;
  big: T;
  large: T;
};

export type AdaptiveHeightsHashTable = BreakpointsHashTable<number>;
export type AdaptivePropsDeclaration = BreakpointsHashTable<string>;
export type PropsDeclarationEntry = [keyof AdaptivePropsDeclaration, number];

const breakPoints: AdaptiveHeightsHashTable = {
  tiny: 480,
  small: 520,
  medium: 560,
  big: 600,
  large: 710,
};

export function constructMediaQueries(prop: string, values: AdaptivePropsDeclaration): string {
  const defaultValue = `${prop}: ${values.tiny};`;

  return Object.entries(breakPoints).reduce(
    (declaration: string, [key, value]: PropsDeclarationEntry) =>
      `${declaration} @media (min-height: ${value}px) { ${prop}: ${values[key]} }`,
    defaultValue
  );
}

type Tuple5<T> = [T, T, T, T, T];
type ValuesTuple = Tuple5<string>;

export function injectAdaptive(prop: string, values: ValuesTuple): string {
  if (!prop || !values) return '';

  const [tiny, small, medium, big, large] = values;
  return constructMediaQueries(prop, {tiny, small, medium, big, large});
}
